import React from 'react';
import PropTypes from 'prop-types';
import { compose, withHandlers, withProps } from 'recompose';
import Select from 'react-select';
import { List } from 'immutable';

import formControl from '../formControl';
import * as styles from '../styles.css';
import withRecruitmentStatusesFetching from '../../../containers/withRecruitmentStatusesFetching';
import withRecruitmentStatuses from '../../../containers/withRecruitmentStatuses';
import { useTranslation } from 'react-i18next';

function RecruitmentStatusSelect({
  input,
  onChange,
  multi,
  disabled,
  isEditable,
  clearable,
  options,
}) {
  const { t } = useTranslation();
  if (!isEditable && !multi) {
    const option = options.find(({ value }) => value === input.value);
    const label = option ? option.label : 'Status saknas...';
    return <div className={styles.value}>{label}</div>;
  }

  return (
    <div style={{ width: '100%' }} data-testid="RecruitmentStatusSelect">
      <Select
        name={input.name}
        placeholder={t("Rekryteringsstatus...")}
        options={options}
        value={List.isList(input.value) ? input.value.toJS() : input.value}
        onChange={onChange}
        multi={multi}
        disabled={disabled}
        clearable={clearable}
      />
    </div>
  );
}

RecruitmentStatusSelect.defaultProps = {
  input: {
    name: 'resourceStatusSelect',
    value: undefined,
  },
  multi: false,
  disabled: false,
  clearable: true,
  isEditable: true,
  options: [],
};

RecruitmentStatusSelect.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(List), PropTypes.number]),
    onChange: PropTypes.func.isRequired,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  multi: PropTypes.bool,
  disabled: PropTypes.bool,
  isEditable: PropTypes.bool,
  clearable: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired,
  })),
};

export default compose(
  withRecruitmentStatusesFetching,
  withRecruitmentStatuses,
  withProps(({ recruitmentStatuses }) => ({
    options: recruitmentStatuses
      .toJS()
      .map(({ id, name }) => ({
        value: id,
        label: name,
      })),
  })),
  formControl,
  withHandlers({
    onChange: ({ input, multi }) => (value) => {
      if (!multi) {
        if (value) {
          input.onChange(value.value);
        } else {
          input.onChange(value);
        }
        return;
      }

      if (!value) {
        input.onChange(new List());
        return;
      }
      input.onChange(new List(value));
    },
  }),
)(RecruitmentStatusSelect);
